import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";
import { PaymentInterface } from "../../Entity/Entities/Payment/PaymentInterface";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import Translator from "../../Translation/Translator";

export default function* paymentCreateAndLink(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAYMENT_CREATE_AND_LINK_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_PAYMENT_CREATE_AND_LINK_REQUEST
    });

    const res = yield call(Http.post, `payment/create-and-link`, {
      payment: action.payload?.payment,
      charge: action.payload?.charge,
      additionalCharge: action.payload?.additionalCharge
    });

    const payment: PaymentInterface = PaymentFactory.create(res.data.data.payment);
    const charge: ChargeInterface = ChargeFactory.create(res.data.data.charge);

    yield put({
      type: Constants.GLOBAL_PAYMENT_CREATE_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_PAYMENT_CREATE_AND_LINK_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-payment-created-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, {payment: payment, charge: charge});
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_CREATE_AND_LINK_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentCreateAndLink() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_CREATE_AND_LINK_START, paymentCreateAndLink);
}
